import { render, staticRenderFns } from "./SdeptCusPrice.vue?vue&type=template&id=b3067344&"
import script from "./SdeptCusPrice.vue?vue&type=script&lang=ts&"
export * from "./SdeptCusPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports